/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import vuetify from "./vuetify";
import router from "../router";

// Types
import type { App } from "vue";
import { i18n } from "@/i18n";
import { createPinia } from "pinia";
import { InitializeSentry } from "@/utils/InitializeSentry";
import { createSentryPiniaPlugin } from "@sentry/vue";
import { initializeTimeZone } from "@/dayjs";

const pinia = createPinia();

export function registerPlugins(app: App) {
    initializeTimeZone();
    pinia.use(createSentryPiniaPlugin());

    app
        .use(i18n)
        .use(pinia)
        .use(vuetify)
        .use(router);

    new InitializeSentry().initialize(app);
}
